module.exports = __webpack_public_path__ + "static/media/clip_image_step1.04164874.svg";